import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AttachmentPoint } from '../../models/attachmentpoint';
import { AttachmentPointService } from '../../services/attachment-point.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupService } from '../../services/group.service';
import { GroupLight } from '../../models/group';


@Component({
  selector: 'app-attachmentpoints-groupbinding',
  templateUrl: './attachmentpoints-groupbinding.component.html',
  styleUrls: ['./attachmentpoints-groupbinding.component.css']
})
export class AttachmentpointsGroupbindingComponent implements OnInit {

  attachmentPoints : Array<AttachmentPoint>;
  visibleGroups : GroupLight[];
  @Output() onValidation = new EventEmitter<boolean>();
  
  constructor(private apService : AttachmentPointService,
              public activeModal : NgbActiveModal,
              private groupService : GroupService) { }


  ngOnInit() {
    this.groupService.loadVisibleGroups().subscribe(res => {
      this.visibleGroups = res;
    });
  }

  listFormatter(data:any) {
    return data.name;
  }

  onSaveClick() {
    // TODO 
  }

}



// WEBPACK FOOTER //
// ./src/app/attachmentpoints/attachmentpoints-groupbinding/attachmentpoints-groupbinding.component.ts